"use client";

import { FlagComponent } from "@/components/form/phone-input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useLangChange } from "@/hooks/use-lang-change";
import { languages } from "@/i18n";
import { getLocaleCountry } from "@/lib/utils";

export const AuthLangSwitcher = () => {
	const { currentLocale, setLang } = useLangChange();

	return (
		<Select defaultValue={currentLocale} onValueChange={setLang}>
			<SelectTrigger className="w-45">
				<SelectValue placeholder="Select language" />
			</SelectTrigger>
			<SelectContent>
				{languages.map((lang) => {
					const { country, countryName } = getLocaleCountry(lang);

					return (
						<SelectItem key={lang} value={lang}>
							<div className="flex items-center gap-2">
								<div className="[&_svg]:w-4">
									<FlagComponent country={country} countryName={countryName} />
								</div>
								<span>{countryName}</span>
							</div>
						</SelectItem>
					);
				})}
			</SelectContent>
		</Select>
	);
};
